<h3 color="primary" class="popup-header">{{isAddNew ? 'Add' : 'Edit'}} Issue</h3>
<mat-dialog-content class="mat-typography">
	<custom-popup-message></custom-popup-message>
	<div fxLayout="column">
		<mat-form-field>
			<mat-select disableOptionCentering placeholder="Issue Type" [(ngModel)]="dataModel.issuetype" required>
				<mat-option>
					<ngx-mat-select-search [(ngModel)]="searchCtrlForIssueType" [placeholderLabel]="'Search...'"
						[noEntriesFoundLabel]="'Not found'" name="search">
					</ngx-mat-select-search>
				</mat-option>
				<mat-option *ngFor="let item of issueTypeList | stringFilterBy:searchCtrlForIssueType:'name'" [value]="item.id">
					{{item?.name}}
				</mat-option>
			</mat-select>
		</mat-form-field>
		<mat-form-field>
			<input matInput placeholder="Summary" maxlength="100" [(ngModel)]="dataModel.summary" required />
		</mat-form-field>
		<mat-form-field>
			<textarea matInput rows="3" placeholder="Description" maxlength="255"
				[(ngModel)]="dataModel.description"></textarea>
		</mat-form-field>
		<mat-form-field appearance="legacy" *ngIf="isInputFileShow">
			<ngx-mat-file-input placeholder="Only PDF or image(.jpg, .jpeg, .png, .gif) files can be attached..."
				[accept]="'.jpg, .jpeg, .png, .gif, .pdf'" [(ngModel)]="file" (change)="fileSelect()" required>
			</ngx-mat-file-input>
			<mat-icon matSuffix fontSet="fas" fontIcon="fa-paperclip"
				style="color: var(--primary);font-size: 14px !important;">
			</mat-icon>
		</mat-form-field>
		<mat-form-field appearance="legacy" *ngIf="!isInputFileShow">
			<input matInput placeholder="Uploaded File" disabled
				[value]="documentAttachment.documentName + '.' + documentAttachment.documentType" />
			<mat-icon matSuffix style="color: var(--primary-warn);cursor: pointer;" matTooltip="Remove File"
				(click)="isInputFileShow=!isInputFileShow">
				delete
			</mat-icon>
		</mat-form-field>
	</div>
</mat-dialog-content>
<mat-dialog-actions class="popup-footer">
	<button mat-raised-button color="primary" (click)="saveClick()">
		<i class="fas fa-check"></i> Save
	</button>
	<button mat-raised-button color="warn" (click)="cancelClick()">
		<i class="fas fa-times"></i> Cancel
	</button>
</mat-dialog-actions>